import { themeStyle } from '@repo/ui/theming';

import { TagTheme } from './types';

export const bigTheme: TagTheme = {
  height: '27px',
  iconHeight: '10px',
  backgroundColor: 'transparent',
  backgroundColorHover: themeStyle.varBackgroundAlt,
  borderColor: 'transparent',
  borderColorHover: themeStyle.varInkLight,
  fontSize: themeStyle.fontSize12,
  lineHeight: '15px',
  letterSpacing: '0.01em',
  borderRadius: '100px',
  padding: '0 14px',
};

export const specialTheme: TagTheme = {
  color: themeStyle.varBrandMain,
  colorHover: themeStyle.varBrandMain,
  borderColor: themeStyle.varBrandMain,
  backgroundColor: themeStyle.varBrandSuperLight,
  fontWeight: themeStyle.fontSemiBold,
  letterSpacing: '1px',
  borderRadius: '100px',
};

export const announcementTheme: TagTheme = {
  color: themeStyle.varBrandMain,
  colorHover: themeStyle.varBrandMain,
  backgroundColor: themeStyle.varBrandLight,
  padding: '0 8px',
  height: '24px',
  borderColor: 'transparent',
  borderRadius: themeStyle.radiusSmall,
  fontWeight: themeStyle.fontMedium,
  fontSize: themeStyle.fontSize11,
};

export const announcementLightTheme: TagTheme = {
  ...announcementTheme,
  backgroundColor: themeStyle.varBrandSuperLight,
};

export const shortcutTheme: TagTheme = {
  height: '16px',
  borderRadius: '2px',
  minWidth: '16px',
  padding: '0 4px',
  backgroundColor: 'transparent',
  borderColor: themeStyle.varInkLightMedium,
  color: themeStyle.varInkLightMedium,
  fontWeight: themeStyle.fontMedium,
};

export const shortcutSingleTheme: TagTheme = {
  ...shortcutTheme,
  maxWidth: '16px',
  justifyContent: 'center',
  padding: '0',
};
